var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stock-type-flag text-capitalize"},[_vm._v(_vm._s(_vm.formatStockType))])
}
var staticRenderFns = []

export { render, staticRenderFns }